import { TooltipProps } from '@typings';
import cx from 'classnames';

import { HelpOutline } from '../Icons';
import { Tooltip } from '../Tooltip';

import styles from './HelpTooltip.module.scss';

interface Props extends Omit<TooltipProps, 'children'> {
  iconClassName?: string;
}

const handleHelpMessageClick = (event: React.MouseEvent<HTMLSpanElement>) => {
  event.preventDefault();
  event.stopPropagation();
};

export const HelpTooltip = ({ content, iconClassName, ...props }: Props) => {
  return (
    <Tooltip content={content} {...props}>
      <span aria-hidden="true" className={cx(styles.icon, iconClassName)} onClick={handleHelpMessageClick}>
        <HelpOutline className="size-4 text-neutral-40" />
      </span>
    </Tooltip>
  );
};
